import { AUTH_HOST, LoginOutUrl, getEnvName } from '@/config'

//检查登录状态
export const checkAndLogin = () => {
  return new Promise((resolve, reject) => {
    var passport_config = {
      base: AUTH_HOST[getEnvName()] + '/'
    }
    probeAuthStatus(
      function(userData) {
        resolve(userData)
      },
      function(error) {
        reject()
        window.location.href = LoginOutUrl
      },
      passport_config
    )
  })
}

// export const checkAndLogin = () => {
//   return new Promise((resolve, reject) => {
//     snVue.passport(
//       function(userData) {
//         resolve(userData)
//         // 已登录
//       },
//       function(res) {
//         // debugger
//         reject(res)
//         // 未登录
//         let url = location.href
//         // 这里有个问题，如果客户端内返回不刷新，targetUrl 要 encodeURIComponent, service 后面的参数要再 encodeURIComponent 一次，两次 encodeURIComponent 可以解决。
//         window.location.href = loginUrl
//       }
//     )
//   })
// }
